import * as actionTypes from '../actions/actionTypes';
import axios from 'axios';

export const authStart = () => {
  return {
    type : actionTypes.AUTH_START
  };
};

export const authSuccess = (token , userId) => {
  return {
    type : actionTypes.AUTH_SUCCESS,
    idToken : token,
    userID : userId
  };
};

export const authFail = (error) => {
  return {
    type : actionTypes.AUTH_FAIL,
    error : error
  };
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('expirationDate');
  localStorage.removeItem('userId');
  return {
    type : actionTypes.AUTH_LOGOUT
  };
};

 const checkAuthTimeOut = (expirationTime) => {
     return dispatch => {
       setTimeout( () => {
          dispatch(logout())
       }, expirationTime * 1000) // will expires token after 1 hour if remove (* 1000) then 3.6 secs
     }
 }
export const auth = (email, password, isSignUp) => {
   return  dispatch => {
     dispatch(authStart());
     const authData = {
       email : email,
       password : password,
       returnSecureToken : true
     }
     let url = 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyCHRPvmiubXJgGIaDW0uES6keMATzsGbrQ';

     if(!isSignUp){
       url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyCHRPvmiubXJgGIaDW0uES6keMATzsGbrQ'
     }
     axios.post(url, authData)
     .then(response => {
       console.log(response);
       const expirationDate = new Date(new Date().getTime() + response.data.expiresIn * 1000);
       localStorage.setItem('token', response.data.idToken);
       localStorage.setItem('expirationDate' ,expirationDate);
       localStorage.setItem('userId', response.data.localId);
       dispatch(authSuccess(response.data.idToken, response.data.localId));
       dispatch(checkAuthTimeOut(response.data.expiresIn));
     })
       .catch(err => {
         console.log(err);
         dispatch(authFail(err.response.data.error))
       })
      }
}  
export const setAuthRedirectPath = (path) => {
  return {
    type : actionTypes.SET_AUTH_REDIRECT_PATH,
    path : path
  }
}
export const authCheckState = () => {
  return dispatch => {
    const token = localStorage.getItem('token');
    if(!token){
      dispatch(logout());
    }
    else {
      const expirationDate = new Date(localStorage.getItem('expirationDate'));
      if(expirationDate <= new Date()){
        dispatch(logout());
      }else {
        const userId = localStorage.getItem('userId')
        dispatch(authSuccess(token, userId));
        dispatch(checkAuthTimeOut(
                                ( expirationDate.getTime() - new Date().getTime() ) /1000
                           ));
      }
    
    }
  }
}